"use client";

import { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';

interface ProfileImageContextType {
  imageUrl: string | null;
  setImageUrl: (url: string | null) => void;
}

const ProfileImageContext = createContext<ProfileImageContextType | undefined>(undefined);

export const ProfileImageProvider = ({ children }: { children: ReactNode }) => {
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  return (
    <ProfileImageContext.Provider value={{ imageUrl, setImageUrl }}>
      {children}
    </ProfileImageContext.Provider>
  );
};

export const useProfileImage = () => {
  const context = useContext(ProfileImageContext);
  if (context === undefined) {
    throw new Error('useProfileImage must be used within a ProfileImageProvider');
  }
  return context;
};
